import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import JobInfoData from './ScheduleNewJobInfoModal';
import JobScheduleVoidModalData from './JobScheduleVoidModal';
import AddNewScheduleData from './ScheduleNewAddModal';
import EditNoteModal from './EditNotes';
import { Link } from 'react-router-dom';
import RescheduleJobData from './ScheduleNewRescheduleModal';
import ConfirmPopups from './ConfirmPopup';

type TiltCraneJobProps = {
    scheduleDate: string;
    scheduleDateFormatted: string;
    scheduleDateFormattedSmall: string;
    scheduleBranchId: number;
    systemCompanyId: number;
    canEdit: boolean;
    scheduleTypes: GenericList[];
    trucks: GenericList[];
    publicHolidays: PublicHoliday[];
    shutdownPeriods: ShutdownPeriod[];
    reasonOptions: GenericList[];
    jobs: TiltCraneJob[];
    saveDayOrder(scheduleDate: string, jobs: TiltCraneJob[]): void;     //saves the day order and updates the list of jobs
    saveJob(scheduleDate: string, jobIndex: number, updatedJob: TiltCraneJob): void;    //saves updated job and only updates that job within the list of jobs
    updateDay(scheduleDate: string): void;
}

type TiltCraneJob = {
    id: number;
    jobId: number;
    jobQuoteItemId: number;
    companyId: number;
    scheduledDate: string;
    truckId: number;
    truck: string;
    truckIsCraneTilt: boolean;
    customerId: number;
    customer: string;
    siteAddress: string;
    description: string;
    manualItem: boolean;
    type: string;
    typeId: number;
    itemId: number;
    item: string;
    itemShortcut: string;
    itemTypeId: number;     //fix this as could be null
    quantityType: string;
    onOffhireDate: string;
    onOffhireDateFormatted: string;
    accountTypeId: number;
    accountType: string;
    accountChecked: boolean;
    goAhead: boolean;
    callout: boolean;
    truckAccess: string;
    parking: string;
    siteClean: string;
    powerlines: string;
    weekdayAccess: string;
    weekendAccess: string;
    phoneCallRequired: string;
    tiltSlideClearance: string;
    plumbingElectricityDisconnected: string;
    extras: string;
    isEws: boolean;
    showRedNotes: boolean;
    showGreenNotes: boolean;
    scheduleNotes: string;
    runsheetNotes: string;
    status: string;
    statusId: number;
    reckonUpdatesRequired: boolean;
    customerUpdatesRequired: boolean;
    craneTruckRequired: boolean;
    jobOrder: number;
    isPlaceholder: boolean;
    purchaseOrderNumber: string;
    rowVersionTimestamp: Uint8Array;
    canEdit: boolean;
    canDelete: boolean;
}

interface GenericList {
    id: number;
    name: string;
}

interface AddNewResults {
    itemIndex: number;
    selected: boolean;
    scheduleId: number;
    scheduleDate: string;
    jobQuoteItemId: number;
    jobId: number;
    siteAddress: string;
    customer: string;
    item: string;
    itemShortcut: string;
    type: string;
    quantityTotal: number;
    quantityScheduled: number;
    quantityType: string;
    hirePeriod: string;
    onoffhireDate: string;
    pickupDate: string;
    bringForwardDate: string;
    bringForwardDateFormatted: string;
    pickupScheduled: boolean;
    callout: boolean;
    allowOnGoingHire: boolean;
    notes: string;
}

interface NewItem {
    jobId: number;
    siteAddress: string;
    customerName: string;
    contactName: string;
    scheduleDate: string;
    scheduleBranchId: number;
    description: string;
    typeId: number;
    notes: string;
    runsheetNotes: string;
    errors: any;
    subId: string;
}

interface PublicHoliday {
    name: string;
    date: string;
}

interface ShutdownPeriod {
    startDate: string;
    endDate: string;
}

const ScheduleTiltCraneJobsData = (props: TiltCraneJobProps) => {
    const [itemCompanyId, setItemCompanyId] = React.useState(0);
    const [showNotes, setShowNotes] = React.useState(false);
    const [editIndex, setEditIndex] = React.useState(-1);
    const [showJobInfo, setShowJobInfo] = React.useState(false);
    const [showVoidGearList, setShowVoidGearList] = React.useState(false);
    const [scheduleId, setScheduleId] = React.useState(-1);
    const [jobQuoteItemId, setJobQuoteItemId] = React.useState(-1);
    const [showAddNew, setShowAddNew] = React.useState(false);
    const [showReschedule, setShowReschedule] = React.useState(false);
    const [showCancel, setShowCancel] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);

    const onGoAheadCheckChange = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        job.goAhead = e.target.checked;
        saveJob(job);
    }

    const onPaidCheckChange = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        job.accountChecked = e.target.checked;
        saveJob(job);
    }

    const onTruckCellChange = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        job.truckId = e.target.value;
        saveJob(job);
    }

    const saveJob = async (job: TiltCraneJob) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var saveTiltCraneJob = {
            id: job.id,
            goAhead: job.goAhead,
            paid: job.accountChecked,
            truckId: job.truckId,
            subId: user.sub,
            rowVersionTimestamp: job.rowVersionTimestamp
        };

        //save
        axios.post('api/Schedule/SaveTiltCraneJob', saveTiltCraneJob, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Job Saved");

                //update current day
                props.updateDay(props.scheduleDate);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //JOB INFO
    const showInfo = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        setEditIndex(jobIndex);
        setScheduleId(job.id);
        setItemCompanyId(job.companyId);
        setShowJobInfo(true);
    }

    const hideJobInfo = () => {
        setEditIndex(-1);
        setShowJobInfo(false);
        setScheduleId(-1);
        setItemCompanyId(0);
        setJobQuoteItemId(-1);
    }

    const openGearlist = () => {
        var job = props.jobs[editIndex];
        setShowJobInfo(false);
        setShowVoidGearList(true);
        setJobQuoteItemId(job.jobQuoteItemId);
    }

    const saveJobInfo = () => {
        setEditIndex(-1);
        setShowJobInfo(false);
        setScheduleId(-1);
        setItemCompanyId(0);
        setJobQuoteItemId(-1);
    }
    //END JOB INFO

    //VOID GEAR LIST
    const hideVoidGearList = () => {
        setShowJobInfo(true);
        setShowVoidGearList(false);
        setJobQuoteItemId(-1);
    }

    const saveVoidGearList = () => {
        setShowJobInfo(true);
        setShowVoidGearList(false);
        setJobQuoteItemId(-1);
    }
    //END VOID GEARLIST

    //RESCHEDULE JOB
    const rescheduleJob = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];

        setShowReschedule(true);
        setScheduleId(job.id);
    }

    const hideReschedule = () => {
        setShowReschedule(false);
        setScheduleId(-1);
    }

    const saveRescheduleItem = (scheduleDateNew: string) => {
        props.updateDay(props.scheduleDate);
        props.updateDay(scheduleDateNew);
        setShowReschedule(false);
        setScheduleId(-1);
    }

    //END RESCHEDULE JOB

    //CANCEL JOB
    const cancelJob = (e: any, jobIndex: number) => {
        e.preventDefault();
        setDeleteIndex(jobIndex);
        setShowCancel(true);
    }

    const hideCancel = () => {
        setDeleteIndex(-1);
        setShowCancel(false);
    }

    const saveCancel = () => {
        saveCancelItem();
    }

    const saveCancelItem = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //get id from item we want to delete
        var job = props.jobs[deleteIndex];

        //update the job status on the database and get the updated item back
        axios.get('api/Schedule/DeleteItem?ScheduleId=' + job.id + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setDeleteIndex(-1);
            setShowCancel(false);
            props.updateDay(props.scheduleDate);

            toast.success("Item has been unscheduled");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END CANCEL JOB

    //NOTES
    const showEditNotes = (e: any, jobIndex: number) => {
        e.preventDefault();
        var job = props.jobs[jobIndex];
        setEditIndex(jobIndex);
        setScheduleId(job.id);
        setItemCompanyId(job.companyId);
        setShowNotes(true);
    }

    const hideNotes = () => {
        setEditIndex(-1);
        setScheduleId(-1);
        setItemCompanyId(0);
        setShowNotes(false);
    }

    const saveNotes = (scheduleNotes: string, timestamp: Uint8Array) => {
        var jobs = props.jobs;
        var job = jobs[editIndex];
        
        job.scheduleNotes = scheduleNotes;
        job.rowVersionTimestamp = timestamp;

        setScheduleId(-1);
        setItemCompanyId(0);
        setShowNotes(false);

        toast.success("Notes Saved");

        props.saveJob(props.scheduleDate, editIndex, job);
        setEditIndex(-1);
    }
    //END NOTES

    //REFRESH DAY
    const refreshDay = () => {
        props.updateDay(props.scheduleDate);
    }

    //END REFRESH DAY

    //ADD NEW
    const add = () => {
        setShowAddNew(true);
    }

    const hideAddNew = () => {
        setShowAddNew(false);
    }

    const saveAddNew = (items: AddNewResults[]) => {
        addScheduleItem(items);
    }

    const addScheduleItem = async (items: AddNewResults[]) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var schedule = {
            scheduleDate: props.scheduleDate,
            scheduleBranchId: props.scheduleBranchId,
            tiltTruckScheduler: true,
            scheduleItems: items,
            subId: user.sub
        };

        //save
        axios.post('api/Schedule/SaveAddNewScheduleItems', schedule, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //reload the day
            toast.success("Schedule Saved");
            setShowAddNew(false);

            //update the other days that have had jobs moved
            var dates = res.data;
            for (var i = 0; i < dates.length; i++) {
                var dateToUpdate = dates[i];
                props.updateDay(dateToUpdate);
            }
            //update current day
            props.updateDay(props.scheduleDate);
        })
        .catch(error => {
            toast.error(error.message);
        });
        
    }

    const saveManualJob = (newManualJob: NewItem) => {
        saveManualItem(newManualJob);
    }

    const saveManualItem = async (newManualJob: NewItem) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        newManualJob.scheduleBranchId = props.scheduleBranchId;
        newManualJob.subId = user.sub;

        axios.post('api/Allocate/SaveNewAllocationItem', newManualJob, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Schedule Saved");
            setShowAddNew(false);
            //this.setState({ showAddNew: false, install: [], pickup: [] });
            //this.props.updateDay(this.props.scheduleDay.scheduledDate, true);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END ADD NEW

    const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
        var jobs = props.jobs;

        if (oldIndex != newIndex) {
            jobs.splice(newIndex, 0, jobs.splice(oldIndex, 1)[0]);

            var jobOrder = 1;
            //loop through the items and update the order
            for (var j = 0; j < jobs.length; j++) {
                let job = jobs[j];

                job.jobOrder = jobOrder;
                jobOrder += 1;
            }
        }

        props.saveDayOrder(props.scheduleDate, jobs);
    }

    const notes = <EditNoteModal systemCompanyId={itemCompanyId} scheduleId={scheduleId} editDriverNotes={false} showDriverScheduleNotes={false} showEditNotesModal={showNotes} save={saveNotes} hideModal={hideNotes} />
    const jobInfo = <JobInfoData systemCompanyId={itemCompanyId} scheduleId={scheduleId} showModal={showJobInfo} hideModal={hideJobInfo} openGearlist={openGearlist} saveModal={saveJobInfo} />
    const editVoidGearlist = <JobScheduleVoidModalData showModal={showVoidGearList} jobQuoteItemId={jobQuoteItemId} hideModal={hideVoidGearList} saveModal={saveVoidGearList} />
    const addNewSchedule = <AddNewScheduleData scheduleDate={props.scheduleDate} dateFormatted={props.scheduleDateFormatted} scheduleTypes={props.scheduleTypes} showModal={showAddNew} hideModal={hideAddNew} save={saveAddNew} saveManual={saveManualJob} />
    const rescheduleJobItem = <RescheduleJobData publicHolidays={props.publicHolidays} shutdownPeriods={props.shutdownPeriods} reasonOptions={props.reasonOptions} showModal={showReschedule} hideModal={hideReschedule} scheduleId={scheduleId} saveModal={saveRescheduleItem} />
    const contents = <SortableList distance={1} onSortEnd={onSortEnd} systemCompanyId={props.systemCompanyId} jobs={props.jobs} trucks={props.trucks} onPaidCheckChange={onPaidCheckChange} onGoAheadCheckChange={onGoAheadCheckChange} onTruckCellChange={onTruckCellChange} showInfo={showInfo} rescheduleJob={rescheduleJob} cancelJob={cancelJob} editNotes={showEditNotes} canEdit={props.canEdit} />
    let confirmCancel = <ConfirmPopups heading="Cancel Job" text="Are you sure you want to cancel this job?" showConfirmModal={showCancel} hideConfirmModal={hideCancel} saveConfirmModal={saveCancel} />

    return (
        <div>
            <div className="static-modal">
                {notes}
                {jobInfo}
                {editVoidGearlist}
                {addNewSchedule}
                {rescheduleJobItem}
                {confirmCancel}
            </div>
            <div>
                <div className="schedulenew__statusBar">
                    <span className="schedulenew__day marginRight10">{props.scheduleDateFormatted}</span>
                    <div>
                        <button className="defaultbutton defaultbutton__small--height marginLeft10" type='button' title="Refreshes the current day" onClick={refreshDay}>Refresh</button>
                        <button className={props.systemCompanyId === 2 && props.canEdit ? "defaultbutton defaultbutton__small--height marginLeft10" : "hidden"} type='button' title="Allows user to add an existing quoted job, dismantle or manual job to the current day" onClick={add}>Add New</button>
                    </div>
                </div>
                <div className="overflowAuto tableColours-header marginTop10">
                    <table className="table table__extralarge">
                        <thead>
                            <tr>
                                <th className="hidden"></th>
                                <th className="table--col-xs"></th>
                                <th className="table--col-xs"></th>
                                <th>Site Address</th>
                                <th>Customer</th>
                                <th className="table--col-s">Item</th>
                                <th className="table--col-s">Qty</th>
                                <th className="table--col-m">On/Offhire Date</th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Acct
                                        <span className="tooltipitemtext tooltipitemtext__right">Account Type - Prepaid, Account, Account Purchase Order</span>
                                    </div>
                                </th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Paid
                                        <span className="tooltipitemtext tooltipitemtext__right">Account is ok / Prepaid account paid</span>
                                    </div>
                                </th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__right">Go/Ah
                                        <span className="tooltipitemtext tooltipitemtext__right">Go-ahead sign off recieved and ready for truck allocation</span>
                                    </div>
                                </th>
                                <th className="table--col-m">Truck</th>
                                <th className="table--col-xs"></th>
                                <th className="table--col-xs">Sch</th>
                                <th className="table--col-s">
                                    <div className="tooltipitem tooltipitem__left">Notes
                                        <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">View/Add Notes to the job</span>
                                    </div>
                                </th>
                                <th className="table--col-xs"></th>
                            </tr>
                        </thead>
                        {contents}
                    </table>
                </div>
            </div>
            
        </div>
    );

}

export default ScheduleTiltCraneJobsData;

//JOBS
const SortableItem = SortableElement(({ jobIndex, systemCompanyId, job, trucks, isBottomRow, showInfo, onPaidCheckChange, onGoAheadCheckChange, onTruckCellChange, rescheduleJob, cancelJob, editNotes, canEdit }: { jobIndex: number, systemCompanyId: number, job: TiltCraneJob, trucks: GenericList[], isBottomRow: boolean, showInfo(e: any, jobIndex: number): void, onPaidCheckChange(e: any, jobIndex: number): void, onGoAheadCheckChange(e: any, jobIndex: number): void, onTruckCellChange(e: any, jobIndex: number): void, rescheduleJob(e: any, jobIndex: number): void, cancelJob(e: any, jobIndex: number): void, editNotes(e: any, jobIndex: number): void, canEdit: boolean }) =>
    <React.Fragment key={jobIndex}>
        <tr className={(job.itemTypeId === 26 || job.itemTypeId === 36) ? "tableColours--pc--oneoff" : job.manualItem ? "tableColours--manual" : job.typeId === 3 ? "tableColours--assist" : job.typeId === 4 ? "tableColours--cleaning" : job.typeId === 5 ? "tableColours--manual" : job.typeId === 1 && job.isPlaceholder ? "tableColours--install-ph" : job.typeId === 1 ? "tableColours--install" : job.typeId === 2 && job.isPlaceholder ? "tableColours--pickup-ph" : job.typeId === 2 ? "tableColours--pickup" : ""}>
            <td className="hidden">{job.id}</td>
            <td className={"table__text--align " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                {jobIndex + 1}
            </td>
            <td className={"table__text--align table--col-xs " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div className="">
                    <a className="tooltipitem tooltipitem__right" href="#" onClick={(e) => showInfo(e, jobIndex)}>
                        <span className="fas fa-info-circle copy--icon alignIconCenter"></span><span className="tooltipitemtext tooltipitemtext__right">Booking Information</span>
                    </a>
                </div>
            </td>
            <td className={"table__text--align"}>
                <Link className={job.jobId === 0 ? "hidden" : (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")} to={'/job/' + job.jobId} target="_blank">
                    <div className="tooltipitem tooltipitem__right">{job.siteAddress && job.siteAddress.length > 30 ? job.siteAddress.substring(0, 30) + "... " : job.siteAddress ? job.siteAddress : ""}
                        <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                    </div>
                </Link>
                <div className={job.jobId === 0 ? "tooltipitem tooltipitem__right" : "hidden"}>{job.siteAddress && job.siteAddress.length > 30 ? job.siteAddress.substring(0, 30) + "... " : job.siteAddress ? job.siteAddress : ""}
                    <span className="tooltipitemtext tooltipitemtext__right">{job.siteAddress}</span>
                </div>
            </td>
            <td className={"table__text--align " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div className="tooltipitem tooltipitem__right">{job.customer.length > 25 ? job.customer.substring(0, 25) + "... " : job.customer}
                    <span className="tooltipitemtext tooltipitemtext__right">{job.customer}</span>
                </div>
            </td>
            <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div className="tooltipitem tooltipitem__right">{job.manualItem ? job.description.substring(0, 5) + "... " : job.itemShortcut}
                    <span className="tooltipitemtext tooltipitemtext__right">{job.manualItem ? job.description : job.item}</span>
                </div>
            </td>
            <td className={"table__text--align table--cell--nowrap table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <span className="tooltipitemtext tooltipitemtext__right">{job.quantityType}</span>
            </td>
            <td className={"table__text--align table--col-m " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                {job.onOffhireDateFormatted}
            </td>
            <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div className="tooltipitem tooltipitem__right">{job.accountTypeId === 1 ? "COD" : job.accountTypeId === 2 ? "Acc" : job.accountTypeId === 3 ? "Acc PO" : ""}
                    <span className="tooltipitemtext tooltipitemtext__right">{job.accountType}</span>
                </div>
            </td>
            <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div>
                    <input name="accountChecked" type='checkbox' className={(canEdit && job.canEdit && job.typeId === 1) ? "input" : "hidden"} checked={job.accountChecked} onChange={(e) => onPaidCheckChange(e, jobIndex)} disabled={systemCompanyId === 3 || job.companyId != systemCompanyId || job.statusId < 2 || job.statusId > 3 || job.truckId > 0 || !canEdit || (job.accountTypeId === 3 && !job.purchaseOrderNumber)} />
                    <div className={job.accountTypeId === 3 && job.typeId === 1 && !job.purchaseOrderNumber ? "tooltipitem tooltipitem__right" : "hidden"}>
                        <span className="fas fa-circle-exclamation makeitred edit--icon marginLeft10"></span>
                        <span className="tooltipitemtext tooltipitemtext__right">Enter Purchase Order Number!</span>
                    </div>
                </div>
            </td>
            <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <div>
                    <input name="goAhead" type='checkbox' className={canEdit && job.canEdit ? "input" : "hidden"} checked={job.goAhead} onChange={(e) => onGoAheadCheckChange(e, jobIndex)} disabled={job.statusId < 2 || job.statusId > 3 || job.truckId > 0 || !canEdit} />
                </div>
            </td>
            <td className={"table__text--align table--col-s " + (job.reckonUpdatesRequired ? "allocate__customerReckonText" : job.customerUpdatesRequired ? "allocate__customerText" : "")}>
                <select className={canEdit && job.canEdit && job.truckIsCraneTilt ? "select" : "hidden"} id="truckId" name="truckId" value={job.truckId} onChange={(e) => onTruckCellChange(e, jobIndex)}>
                    <option defaultValue="-1" value={-1}></option>
                    {trucks.map(truck =>
                        <option key={truck.id} value={truck.id}>{truck.name}</option>
                    )};
                </select>
                {canEdit && job.canEdit && job.truckIsCraneTilt ? "" : job.truck} 
            </td>
            <td className="table__text--align table--col-s">
                <span className={job.craneTruckRequired ? "alignIconCenter tooltipitem tooltipitem__left" : "hidden"}>
                    <span className="fa-solid fa-circle-exclamation copy--icon makeitred"></span>
                    <span className="tooltipitemtext  tooltipitemtext__large tooltipitemtext__left">Crane Truck Required</span>
                </span>
            </td>
            <td className="table__text--align table--col-xs">
                <div className={canEdit && job.canEdit && job.truckIsCraneTilt ? "" : "hidden"}>
                    <a href="#" onClick={(e) => rescheduleJob(e, jobIndex)}>
                        <span className="fas fa-calendar-alt copy--icon alignIconCenter tooltipitem tooltipitem__left"><span className="tooltipitemtext tooltipitemtext__left">Reschedule job to another day</span></span>
                    </a>
                </div>
            </td>
            <td className="table__text--align allocate-notes--width">
                <a className={job.scheduleNotes == "" ? "hidden" : job.showRedNotes ? " makeitred" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, jobIndex)}>
                    <div className="tooltipitem tooltipitem__left">{job.scheduleNotes ? job.scheduleNotes.length < 60 ? job.scheduleNotes : job.scheduleNotes.substring(0, 60) + "... " : ""}
                        <span className="tooltipitemtext tooltipitemtext__left">{job.scheduleNotes}</span>
                    </div>
                </a>
                <a className={job.scheduleNotes != "" ? "hidden" : job.showRedNotes ? " makeitred" : job.showGreenNotes ? " makeitgreen" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => editNotes(e, jobIndex)}>
                    <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                </a>
            </td>
            <td className="table__text--align table--col-xs">
                {canEdit && job.canDelete && job.truckIsCraneTilt && job.companyId == systemCompanyId && job.companyId == 2 ?
                    <div className="delete--tablecell tooltipitem tooltipitem__left">
                        <a href="#" onClick={(e) => cancelJob(e, jobIndex)}>
                            <span className="fas fa-times-circle edit--icon alignIconCenter makeitred tooltipitem tooltipitem__left"></span><span className="tooltipitemtext tooltipitemtext__left">Cancel Booking</span>
                        </a>
                    </div> : ""
                }
            </td>
        </tr>
    </React.Fragment>
);

const SortableList = SortableContainer(({ systemCompanyId, jobs, trucks, showInfo, onPaidCheckChange, onGoAheadCheckChange, onTruckCellChange, rescheduleJob, cancelJob, editNotes, canEdit }: { systemCompanyId: number, jobs: TiltCraneJob[], trucks: GenericList[], showInfo(e: any, jobIndex: number): void, onPaidCheckChange(e: any, jobIndex: number): void, onGoAheadCheckChange(e: any, jobIndex: number): void, onTruckCellChange(e: any, jobIndex: number): void, rescheduleJob(e: any, jobIndex: number): void, cancelJob(e: any, jobIndex: number): void, editNotes(e: any, jobIndex: number): void, canEdit: boolean }) => {
    var bottomRows = jobs.length > 6 ? jobs.length - 3 : jobs.length > 0 ? jobs.length - 1 : jobs.length;

    return (
        <tbody>
            {jobs.map((job, index) =>
                <SortableItem key={`item-${index}`} index={index} jobIndex={index} systemCompanyId={systemCompanyId} job={job} trucks={trucks} isBottomRow={index >= bottomRows} showInfo={showInfo} onPaidCheckChange={onPaidCheckChange} onGoAheadCheckChange={onGoAheadCheckChange} onTruckCellChange={onTruckCellChange} rescheduleJob={rescheduleJob} cancelJob={cancelJob} editNotes={editNotes} canEdit={canEdit} />
            )}
        </tbody>
    );

});

